<template>
  <div class="editor-container" :class="{ 'editor-has-value': hasValue }">
    <label class="editor-label" v-if="hasValue">{{ placeholder }}</label>

    <quillEditor
      :value="value"
      @input="onInput"
      class="editor"
      ref="quillEditor"
      :options="editorOption"
      @change="onEditorChange"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @ready="onEditorReady($event)"
      @resize="onResizeHandler"
    />
  </div>
</template>

<script>
import Quill from "quill";
import ImageResize from "quill-image-resize-module";
import MagicUrl from "quill-magic-url";

Quill.register("modules/magicUrl", MagicUrl);
Quill.register("modules/imageResize", ImageResize);

import "quill/dist/quill.core.css"; // import styles
import "quill/dist/quill.snow.css"; // for snow theme
import "quill/dist/quill.bubble.css"; // for bubble theme

import { quillEditor } from "vue-quill-editor";

export default {
  components: {
    quillEditor,
  },
  props: {
    value: {
      default: () => null,
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showLabel: true,
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            [{ list: "bullet" }],
            [{ color: [] }],
            [{ align: [] }],
            ["link", "image", "video"],
          ],
          imageResize: true,
          magicUrl: true,
        },
        placeholder: "",
      },
      hasValue: null,
    };
  },
  beforeMount() {
    this.editorOption.placeholder = this.placeholder;
  },
  methods: {
    onInput(value) {
      this.$emit("input", value);
    },
    // eslint-disable-next-line no-unused-vars
    onEditorBlur(quill) {},
    // eslint-disable-next-line no-unused-vars
    onEditorFocus(quill) {},
    // eslint-disable-next-line no-unused-vars
    onEditorReady(quill) {},
    onEditorChange({ text }) {
      this.$emit("updateQuillEditor", true);
      this.hasValue = !!text.replace(/\n/g, "").trim();
    },
    onResizeHandler() {
      console.log(this.editorContainerHeight);
    },
  },
};
</script>

<style lang="scss">
.editor-container {
  position: relative;
  svg {
    color: #000000;
  }
  .editor-label {
    color: #103f5e;
    margin-top: 8px;
    margin-inline-end: 0;
    margin-bottom: 0;
    margin-inline-start: 15px;
    font-size: 15px;
    font-weight: 700;
    line-height: 17px;
    letter-spacing: 0.25px;
    text-align: start;
    z-index: 99;
  }

  .ql-editor.ql-blank {
    p {
      margin-inline-start: -1px;
    }
  }
  .quill-editor {
    border: none !important;
    min-height: 124px !important;
    position: relative;
    margin-bottom: 55px;
  }

  .ql-container.ql-snow {
    border: none !important;
  }

  .ql-container {
    border-radius: 4px 4px 0px 0px !important;
    overflow: hidden;
    resize: vertical;
  }

  .ql-toolbar.ql-snow {
    border: none !important;
  }

  .ql-toolbar {
    position: absolute;
    bottom: 0;
    width: 100%;
    transform: translateY(100%);
    background-color: rgb(242, 242, 242);
    border-radius: 0px 0px 4px 4px !important;
    z-index: 999;
  }

  .ql-editor {
    min-height: 124px !important;
    text-align: start;
  }

  ::-webkit-scrollbar {
    width: 9px !important;
  }
  ::-webkit-scrollbar-track {
    background: #c7c7c7;
    padding-top: 30px !important;
    border-radius: 8.5px;
    -webkit-box-shadow: #ffff;
    margin-top: 21px !important;
    margin-bottom: 13px !important;
  }
  ::-webkit-scrollbar-thumb {
    background: #666666;
    border-radius: 8.5px;
  }

  .ql-tooltip {
    inset-inline-start: 0px !important;
  }

  .ql-editor.ql-blank::before {
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 19.2px !important;
    letter-spacing: 0.25px !important;
    font-style: normal;
    color: #787878;
  }
}
</style>
